module.exports = __webpack_public_path__ + "src/assets/img/osm-icon.2190eea2.png";